import type { Board } from "../board";
import { getMobGoldValue } from "../economy/mobGoldValues";
import { DamageType } from "../damageType";
import { BasicAI } from "../ai/basicAI";
import { deserializeXY } from "../serialization";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Mob } from "../mob";
import { ParticleType } from "../particleType";
import type { PhysicalThing } from "../physicalThing";
import { SolidifiedSlugant } from "../things/solidifiedSlugant";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { SlugantCorpse } from "./slugantCorpse";

export class Slugant extends Mob {
	static key = "Slugant";
	private ai: BasicAI;

	constructor(xy: XY) {
		super(xy);
		this.resistsPermanentFreeze = true;
		this.damageMultipliers.set(DamageType.MELEE, 0.5);
		this.ai = new BasicAI(this);
		this.ai.attackSoundSupplier = () => new Sound(SoundId.MOB_PHISICAL_ATTACK, this.xy);
	}

	override applyDamage(type: DamageType | null, amount: number, source: Thing | null): number {
		if (type === DamageType.BUBBLE && this.active && this.board) {
			this.board.addThing(new SolidifiedSlugant(this.xy, SolidifiedSlugant.DEFAULT_TURNS, this.gold));
			this.board.removeAtEndOfTurn(this);
			return 0;
		}
		return super.applyDamage(type, amount, source);
	}

	override getBaseGoldValue(): number {
		return getMobGoldValue(Slugant.key);
	}

	override getBloodParticleType(): ParticleType {
		return ParticleType.BLOOD;
	}

	generateCorpse(): PhysicalThing | null {
		return new SlugantCorpse(this.xy);
	}

	processMobAction(_board: Board): void {
		this.ai.processTurn();
	}

	static deserialize(data: any): Slugant {
		const m = new Slugant(deserializeXY(data.xy));
		m.restoreMobFields(data);
		return m;
	}
}
